(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mobileQuery = window.matchMedia('(max-width: 749px)');

    const setupFooterAccordions = () => {
      document
        .querySelectorAll("[id$='__footer_m9NzUG'] .footer-content")
        .forEach((content) => {
          Array.from(content.children)
            .slice(0, 3)
            .forEach((row) => {
              if (row.dataset.sisiFooterAccordion === 'ready') return;
              row.dataset.sisiFooterAccordion = 'ready';
              row.setAttribute('role', 'button');
              row.setAttribute('tabindex', '0');
              row.setAttribute('aria-expanded', 'false');

              const toggle = () => {
                if (!mobileQuery.matches) return;
                const isOpen = row.classList.toggle('is-open');
                row.setAttribute('aria-expanded', String(isOpen));
              };

              row.addEventListener('click', (event) => {
                if (event.target.closest('a')) return;
                toggle();
              });

              row.addEventListener('keydown', (event) => {
                if (event.key !== 'Enter' && event.key !== ' ') return;
                event.preventDefault();
                toggle();
              });
            });
        });
    };

    setupFooterAccordions();
    document.addEventListener('DOMContentLoaded', setupFooterAccordions);
    document.addEventListener('shopify:section:load', setupFooterAccordions);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sisiyuyu-faq-hub"] && !Shopify.designMode) return;
  try {
    
  class SisiFaqHub {
    constructor(section) {
      this.section = section;
      this.tabs = Array.from(section.querySelectorAll('[data-sisi-faq-tab]'));
      this.items = Array.from(section.querySelectorAll('[data-sisi-faq-item]'));
      this.active = section.dataset.sisiFaqDefault || 'shipping';

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.setCategory(tab.dataset.sisiFaqTab));
      });

      this.setCategory(this.active);
    }

    setCategory(category) {
      this.active = category;
      this.tabs.forEach((tab) => {
        tab.classList.toggle('is-active', tab.dataset.sisiFaqTab === category);
      });
      this.items.forEach((item) => {
        const visible = item.dataset.sisiFaqItem === category;
        item.classList.toggle('is-visible', visible);
        item.removeAttribute('open');
      });
    }
  }

  document.querySelectorAll('.sisi-faq-hub').forEach((section) => {
    new SisiFaqHub(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sisiyuyu-review-platform-strip"] && !Shopify.designMode) return;
  try {
    
  class SisiReviewPlatformStrip {
    constructor(section) {
      this.section = section;
      this.track = section.querySelector('.sisi-review-platform-strip__grid');
      this.cards = Array.from(section.querySelectorAll('.sisi-review-platform-strip__card'));
      this.dots = Array.from(section.querySelectorAll('[data-sisi-review-dot]'));
      this.next = section.querySelector('.sisi-review-platform-strip__next');
      this.activeIndex = 0;

      if (!this.track || this.cards.length < 2) return;

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.goTo(index));
      });

      if (this.next) {
        this.next.addEventListener('click', () => this.goTo((this.activeIndex + 1) % this.cards.length));
      }

      this.track.addEventListener('scroll', () => this.syncFromScroll(), { passive: true });
    }

    goTo(index) {
      const card = this.cards[index];
      if (!card) return;

      this.activeIndex = index;
      this.updateDots();
      this.track.scrollTo({
        left: card.offsetLeft - this.track.offsetLeft - 24,
        behavior: 'smooth',
      });
    }

    syncFromScroll() {
      const trackLeft = this.track.scrollLeft;
      let closestIndex = 0;
      let closestDistance = Infinity;

      this.cards.forEach((card, index) => {
        const distance = Math.abs(card.offsetLeft - this.track.offsetLeft - 24 - trackLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      if (closestIndex !== this.activeIndex) {
        this.activeIndex = closestIndex;
        this.updateDots();
      }
    }

    updateDots() {
      this.dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === this.activeIndex);
      });
    }
  }

  document.querySelectorAll('.sisi-review-platform-strip').forEach((section) => {
    new SisiReviewPlatformStrip(section);
  });

  } catch(e) { console.error(e); }
})();
})();
